import "/_components/cookiebanner/cookiebanner.js";
import "/_components/countup/countup.ts";
import "/_components/hero/hero.ts";
import "/_components/home/home.ts";
import "/_components/hotspot/hotspot.ts";

import "/_components/navigation/navigation.ts";

import "/_components/scroll-reveal/scroll-reveal.ts";
import "/_components/slider/slider.ts";
// import "/_components/table/table.ts";

import "/_atoms/animation/animation.ts";
